class EventProduct {
  constructor(data) {
    data = data || {};
    this.id = data.id || null;
    this.events_id = data.events_id || null;
    this.brands_id = data.brands_id || null;
    this.product_labels_id = data.product_labels_id || null;
    this.brand_name = data.brand_name || '';
    this.label_name = data.label_name || '';
    this.type = data.type || null;

    // Data fields (editable by staff)
    // Parse numeric fields to actual numbers — PostgreSQL numeric(10,2) returns strings like "10.00"
    // which AngularJS input[type=number] ng-model rejects with ngModel:numfmt errors.
    this.on_display = data.on_display || null;
    this.regular_price = parseFloat(data.regular_price) || 0;
    this.feature_price = parseFloat(data.feature_price) || 0;
    this.total_inventory = parseFloat(data.total_inventory) || 0;
    this.total_sampled = parseFloat(data.total_sampled) || 0;
    this.percentage_known = parseInt(data.percentage_known, 10) || 0;
    this.product_feedback = data.product_feedback || '';

    // Issue fields
    this.product_issues_id = data.product_issues_id || null;
    this.issue_notes = data.issue_notes || '';

    // Merge issue data if provided separately
    if (data.issue) {
      this.product_issues_id = data.issue.product_issues_id || null;
      this.issue_notes = data.issue.notes || '';
    }
  }

  get productKey() {
    return `${this.brands_id}_${this.product_labels_id || ''}`;
  }

  get displayName() {
    if (this.label_name) {
      return `${this.brand_name} - ${this.label_name}`;
    }
    return this.brand_name;
  }

  serializeData() {
    return {
      on_display: this.on_display,
      regular_price: this.regular_price,
      feature_price: this.feature_price,
      total: this.total_inventory,
      sampled: this.total_sampled,
      percentage_known: this.percentage_known,
      product_feedback: this.product_feedback,
    };
  }

  serializeIssue() {
    return {
      product_issues_id: this.product_issues_id,
      notes: this.issue_notes,
    };
  }
}

export default EventProduct;
